
import moon from "../../assets/moon.svg"
import sun from "../../assets/sun.svg"
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from 'react-redux';
import { toggleDarkMode } from '../../slices/darkModeSlice';
import { AnimatePresence, motion } from "framer-motion";

export default function PopoverSettings({setIsSettingsPopover,settingsPopover}) {
  const dispatch = useDispatch();
  const { isDarkMode } = useSelector((state) => state.darkMode);

  return (
    <AnimatePresence>
      {settingsPopover && (

      
    <motion.div
      onClick={() => setIsSettingsPopover(false)}
      className="fixed inset-0 flex items-start sm:pt-[75px] pt-[60px]  sm:mr-20 mr-6  justify-end z-20  "
      initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
    >
    <motion.div  onClick={(e) => e.stopPropagation()} // Evita que el clic cierre el modal cuando se hace clic dentro
        initial={{ opacity: 0, y: -20 }} // Estado inicial: transparente y un poco arriba
        animate={{ opacity: 1, y: 0 }} // Animación al aparecer
        exit={{ opacity: 0, y: -20 }} // Animación al desaparecer
        transition={{ duration: 0.3, ease: "easeOut" }}  
        className="w-[170px] bg-background shadow-md p-2 rounded border border-border "
        >
      <button onClick={() => dispatch(toggleDarkMode())}>
        {isDarkMode ? (
          <div className='flex'>
          <SunIcon className="text-white w-5 mr-2 " />
            <p className='text-text'>Modo claro</p>
          </div>
        ) : (
          <div className='flex'>
          <MoonIcon className="w-5 mr-2" />
          <p className='text-text'>Modo Oscuro</p>
          </div>
        )}
      </button>
    </motion.div>
    </motion.div>
    )}
    </AnimatePresence>
  )
}
